import {gql} from "graphql-request";

export const UpdateUser = gql`
  mutation UpdateUser($user:UpdateUserInput!) {
    updateUser(input: $user) {
      id
      displayName
      fullName
      email
      avatar {
        lgUrl
        metadata
      }
      measurementPreference
      mapOrientation
      overZoom
      unitPreference
      hikeTime
      hikeTimeDistance
      hikeTimeElevation
      emailNotification
      pushNotification
      routeStyleSettings {
        routeType
        color
        thicknessMultiplier
        opacity
        hideMileMarkers
      }
      hikeListOverlaySettings {
        active
        selectedIds
      }
    }
  }
`;

export const GetUser = gql`
  query GetUser($firebaseID:String!) {
    user(firebaseUserId:$firebaseID){
      id
      title
      userJwt
      fullName
      displayName
      email
      country {
        id
        name
      }
      avatar {
        mdUrl
        metadata
      }
      appSettings {
        name
        active
      }
      admin
      likesDayTrails
      likesMultidayTrails
      likesOvernightTrails
      viewedTrails {
        id
        trail {
          id
          name
          jumboImage {
            id
            url
            metadata
          }
          trailDistance
          totalElevation
          difficulty
          averageRating
          numberOfRatings
          durationString
          shortAddress
        }
      }
      measurementPreference
      mapOrientation
      overZoom
      unitPreference
      hikeTime
      hikeTimeDistance
      hikeTimeElevation
      gridReference
      emailNotification
      pushNotification
      routeStyleSettings {
        routeType
        color
        thicknessMultiplier
        opacity
        hideMileMarkers
      }
      hikeListOverlaySettings {
        active
        selectedIds
      }
    }
  }
`;

export const GetUserTrailLists = gql`
  query GetUserTrailLists {
    userTrailLists {
      id
      name
          createdAt
      trails {
        id
        name
        jumboImage {
          id
          url
          metadata
        }
        trailDistance
        totalElevation
        difficulty
        averageRating
        numberOfRatings
        durationString
        shortAddress
      }
    }
  }
`;

export const CreateTrailList = gql`
  mutation createTrailList($trailList:CreateTrailListInput!) {
    createTrailList(input:$trailList) {
      id
      name
      errors {
        fieldName
        errors
      }
    }
  }
`;


export const UpdateTrailList = gql`
  mutation updateTrailList($trailList:UpdateTrailListInput!) {
    updateTrailList(input:$trailList) {
      id
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const DestroyTrailList = gql`
  mutation destroyTrailList($trailList:DestroyTrailListInput!) {
    destroyTrailList(input:$trailList) {
      id
      destroyed
      errors {
        fieldName
        errors
      }
    }
  }
`;

// Only consumed by the add-to-list modal, which renders each list's name and
// whether the current hike is a member — so only hike ids are fetched. The
// full per-hike card payload this used to pull made opening the modal slow.
export const GetUserHikeLists = gql`
  query GetUserHikeLists {
    userHikeLists {
      id
      name
      hikesCount
      hikes {
        id
      }
    }
  }
`;

export const GetUserHomepageableHikeLists = gql`
  query GetUserHomepageableHikeLists {
    userHomepageableHikeLists {
      id
      name
      description
      homepageable
      publiclyVisible
      hikesCount
      createdAt
      hikes {
        id
        name
        description
        difficulty
        slug
        mainCountry {
          slug
        }
        mainRegion {
          slug
        }
        distanceMeters
        elevationGainMeters
        elevationLossMeters
        primaryImageUrl
        averageRating
        ratingsCount
      }
    }
  }
`;

export const CreateHikeList = gql`
  mutation createHikeList($input: CreateHikeListInput!) {
    createHikeList(input: $input) {
      hikeList {
        id
        name
        description
        publiclyVisible
        hikesCount
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const AddHikeToList = gql`
  mutation addHikeToList($input: AddHikeToListInput!) {
    addHikeToList(input: $input) {
      hikeList {
        id
        name
        hikesCount
      }
      hikesHikeList {
        id
        position
        notes
      }
      errors {
        fieldName
        errors
      }
    }
  }
`;

export const RemoveHikeFromList = gql`
  mutation removeHikeFromList($input: RemoveHikeFromListInput!) {
    removeHikeFromList(input: $input) {
      hikeList {
        id
        name
        hikesCount
      }
      success
      errors {
        fieldName
        errors
      }
    }
  }
`;

// Presign an avatar upload. Same mutation the comments and planned-trail
// uploads use; each domain file keeps its own copy of the document, which is
// the existing convention in this directory.
export const GenerateDirectUpload = gql`
  mutation GenerateDirectUpload($input: GenerateDirectUploadInput!) {
    generateDirectUpload(input: $input) {
      uploadUrl
      headers
      signedId
    }
  }
`;
